<template>
  <v-navigation-drawer v-model="drawer.status" app v-if="status && !post_login_action_required" clipped width="250" color="#fff" class="pt-15">
    <v-list dense nav height="100%" class="py-0 px-3">
      <div v-for="item in nav" :key="item.title">
        <v-list-item link class="nav-button px-5 ma-0 mb-1" :class="{ listActive: checkCurrentRoute(item.route) }" @click="routeTo(item.route)">
          <v-list-item-action>
            <v-icon :class="{ listActive: checkCurrentRoute(item.route) }">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title :class="{ listActive: checkCurrentRoute(item.route) }" class="nav-text">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>
    <template v-slot:append>
      <v-card rounded="0" class="pb-7 px-4" flat>
        <v-row no-gutters>
          <v-btn @click="logout" outlined block class="logout-button text-none"><v-icon>mdi-logout</v-icon> Logout</v-btn>
        </v-row>
      </v-card>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DrawerBar',
  computed: {
    ...mapState(['auth', 'drawer', 'userSetting']),
    status() {
      return this.auth.status
    },
    post_login_action_required() {
      return this.auth.post_login_action_required
    },
    page_access() {
      return this.auth.page_access
    },
    username() {
      return this.auth.username
    },
    role_id() {
      return this.auth.role_id
    },
    role() {
      return this.userSetting.role_list.find((role) => role.value === this.role_id).text
    },
    nav() {
      const routes = this.drawer.nav_items
      if (this.page_access === 'all') return routes
      return routes.filter((route) => this.page_access.includes(route.route))
    }
  },
  methods: {
    routeTo(path) {
      if (this.$route.path !== path) {
        this.$router.push({ path: path })
      }
    },

    logout() {
      this.$store.dispatch('logoutUser')
    },
    checkCurrentRoute(currentRoute) {
      return this.$route.path.split('/')[1] === currentRoute.split('/')[1]
    }
  }
}
</script>

<style scoped>
.v-navigation-drawer /deep/ .v-navigation-drawer__border {
  display: none;
}

.v-list-item__action:first-child {
  margin-right: 16px !important;
}
.v-list-item__title {
  color: rgba(0, 0, 0, 0.87) !important;
}

.v-icon {
  color: rgba(0, 0, 0, 0.87) !important;
}

.nav-button {
  border-radius: 16px !important;
  margin-left: 10px;
  margin-right: 10px;
  width: auto;
  height: 45px;
  align-self: center;
}

.nav-button:hover,
.v-list-item:before {
  border-radius: 16px !important;
}

.listActive {
  background-color: #ffc62e;
}

.nav-text {
  color: #333 !important;
  font-family: 'Nunito Sans';
  font-size: 14px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: 24px !important;
}

.logout-button {
  border-radius: 18px !important;
}
</style>
